// extracted by mini-css-extract-plugin
export default {"price":"l7-z","priceRow":"m7-z","onSale":"n7-z","msrpLabelPrice":"o7-z","msrpLabel":"p7-z","originalPrice":"q7-z","percentOff":"r7-z"};